var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppConfirmationModal",
    _vm._b(
      {
        attrs: { persistent: "", "max-width": "500px", loading: _vm.loading },
        on: {
          input: function ($event) {
            return _vm.$emit("input", $event)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(_vm._s(_vm.$t("WaterQualityReportErrorModal.titleMsg"))),
              ]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  [
                    _c("v-flex", { attrs: { xs12: "", "pb-4": "" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.customTitle == null
                            ? _vm.defaultTitle
                            : _vm.customTitle
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs12: "" } },
                      [
                        _vm.itemLength
                          ? _c(
                              "v-expansion-panel",
                              [
                                _c(
                                  "v-expansion-panel-content",
                                  {
                                    key: "header",
                                    staticClass: "elevation-3",
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "header",
                                          fn: function () {
                                            return [
                                              _c(
                                                "div",
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "WaterQualityReportErrorModal.errorMessage",
                                                          {
                                                            msg: _vm.pluralize(
                                                              "Message",
                                                              _vm.itemLength
                                                            ),
                                                          }
                                                        )
                                                      ) +
                                                      "\n                "
                                                  ),
                                                  _c("v-chip", [
                                                    _vm._v(
                                                      _vm._s(_vm.itemLength)
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      3345608591
                                    ),
                                  },
                                  [
                                    _vm._v(" "),
                                    _c(
                                      "v-expansion-panel",
                                      [
                                        _vm.isUnhandledException
                                          ? _vm._l(_vm.data, function (item) {
                                              return _c(
                                                "v-expansion-panel-content",
                                                {
                                                  key: item,
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "header",
                                                        fn: function () {
                                                          return [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(item)
                                                              ),
                                                            ]),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }
                                              )
                                            })
                                          : [
                                              _vm.hasAnalyteGuidelineUnitMismatchExceptionRecord
                                                ? _c(
                                                    "analyte-guideline-unit-mismatch-record-item",
                                                    {
                                                      attrs: {
                                                        itemData:
                                                          _vm.data
                                                            .AnalyteGuidelineUnitMismatchExceptionRecord
                                                            .Errors,
                                                      },
                                                    }
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.hasAnalyteLabResultUnitMismatchExceptionRecord
                                                ? _c(
                                                    "analyte-labResult-unit-mismatch-record-item",
                                                    {
                                                      attrs: {
                                                        itemData:
                                                          _vm.data
                                                            .AnalyteLabResultUnitMismatchExceptionRecord
                                                            .Errors,
                                                      },
                                                    }
                                                  )
                                                : _vm._e(),
                                            ],
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _vm.customTitle == null
                  ? _c(
                      "PrimaryBtn",
                      {
                        attrs: { color: "warning" },
                        on: { click: _vm._emitDownload },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "WaterQualityReportErrorModal.downloadAnyway"
                            )
                          )
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("SecondaryBtn", { on: { click: _vm._emitCancel } }, [
                  _vm._v(_vm._s(_vm.$t("Button.Close"))),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      },
      "AppConfirmationModal",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }